import { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import swal from "sweetalert";

import { EyePasswordBtn } from "../../../common/ui/view/CustomEyePasswordBtn";
import { resetIndividualUserPassword } from "../../../services/adminApiService/individualApiService/IndividualAPiService";
import { validateResetPassword } from "../accountManagement/AccountEditValidation";

export default function IndividualResetPassword({
    showResetModal,
    setShowResetModal,
    userId
}) {

    const [formData, setFormData] = useState({
        password: "",
        confirm_password: ""
    });

    const [errors, setErrors] = useState({});
    const [backendErrors, setBackendErrors] = useState({});

    const [loading, setLoading] = useState(false);

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData({
            ...formData,
            [name]: value
        });

        setErrors({
            ...errors,
            [name]: ""
        });

        setBackendErrors({
            ...backendErrors,
            [name]: ""
        });
    };

    const handleResetPassword = async () => {

        const validationErrors = validateResetPassword(formData);

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        try {
            setLoading(true);
            setBackendErrors({});

            const payload = {
                password: formData.password,
                confirm_password: formData.confirm_password
            };

            const response = await resetIndividualUserPassword(userId, payload);

            swal("Success", response?.data?.message, "success");

            handleCloseModal();

        } catch (error) {

            if (error?.response?.data?.errors) {
                setBackendErrors(error.response.data.errors);
            }

            if (error?.response?.data?.message) {
                swal("Error", error.response.data.message, "error");
            }

        } finally {
            setLoading(false);
        }
    };

    const handleCloseModal = () => {
        setFormData({
            password: "",
            confirm_password: ""
        });

        setErrors({});
        setBackendErrors({});
        setShowPassword(false);
        setShowConfirmPassword(false);

        setShowResetModal(false);
    };

    return (
        <Modal
            show={showResetModal}
            onHide={handleCloseModal}
            centered
        >
            <Modal.Body className="p-4">

                <h5 className="fw-semibold mb-3">Reset User Password</h5>

                <div className="row">
                    {[
                        {
                            label: "Create Password",
                            name: "password",
                            placeholder: "Password",
                        },
                        {
                            label: "Confirm Password",
                            name: "confirm_password",
                            placeholder: "Confirm Password",
                        }
                    ].map(({ label, name, placeholder }) => (
                        <div key={name} className="col-md-12 mb-3">
                            <label className="text-black font-w500">
                                {label} <span className="text-danger">*</span>
                            </label>
                            <div className="password-input-container">
                                <Form.Control
                                    type={
                                        name === "password"
                                            ? (showPassword ? "text" : "password")
                                            : (showConfirmPassword ? "text" : "password")
                                    }
                                    name={name}
                                    value={formData[name]}
                                    placeholder={placeholder}
                                    onChange={handleChange}
                                    isInvalid={!!errors[name]}
                                />

                                {name === "password" && (
                                    <EyePasswordBtn
                                        showPassword={showPassword}
                                        setShowPassword={setShowPassword}
                                        hasError={!!errors[name]}
                                    />
                                )}

                                {name === "confirm_password" && (
                                    <EyePasswordBtn
                                        showPassword={showConfirmPassword}
                                        setShowPassword={setShowConfirmPassword}
                                        hasError={!!errors[name]}
                                    />
                                )}
                            </div>

                            <Form.Control.Feedback type="invalid" className="d-block text-danger">
                                {errors[name] || backendErrors?.[name]}
                            </Form.Control.Feedback>

                        </div>
                    ))}
                </div>
                <ul className="ps-3 text-muted small mb-4 wrapper_of_account_list">
                    <li>At least 8 characters</li>
                    <li>One uppercase, one number, one special character</li>
                </ul>

                <div className="d-flex justify-content-end gap-2 mt-4">
                    <Button
                        variant="outline-secondary"
                        onClick={handleCloseModal}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="primary"
                        onClick={handleResetPassword}
                        disabled={loading}
                    >
                        {loading ? "Resetting..." : "Reset Password"}
                    </Button>
                </div>

            </Modal.Body>
        </Modal>
    );
}
